export default __webpack_public_path__ + "static/media/Q10_給你舒緩放鬆的平靜.aa88bf86.mp4";